import { AppLayout } from "@/components/layout/app-layout";
import { PageHeader } from "@/components/layout/page-header";
import { ReportsTabs } from "@/components/reports/reports-tabs";
import { useMemo } from "react";
import { useAuth } from "@/contexts/auth-context";

const Reports = () => {
  const { organization } = useAuth();

  const organizationName = organization?.name ?? "Swiss Finance OS";

  const periodLabel = useMemo(() => {
      const now = new Date();
    const quarter = Math.floor(now.getMonth() / 3) + 1;
    return `Q${quarter} ${now.getFullYear()}`;
  }, []);

  return (
    <AppLayout>
        <PageHeader 
        title="Berichte & Export"
        subtitle={`${organizationName} • ${periodLabel}`}
      />
      
      <main className="flex-1 p-page-padding lg:p-page-padding-lg">
        <ReportsTabs />
        </main>
    </AppLayout>
  );
};

export default Reports;